var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPresent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 34,
  "aria-hidden": "true",
  viewBox: "0 0 30 34"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BFE9D6",
  fillRule: "nonzero",
  d: "M3 17h24v4H3z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#00BD70",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m4 5 10 5.97L11 3 4 1zM26 5l-10 5.97L19 3l7-2zM1 11h28v6H1zM3 17h24v16H3zM15 33V11"
}))));
export default SvgPresent;